import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-brand-header">
              <img src="/assets/images/TMC-logo.png" alt="Tahoe Mountain Cars Logo" className="footer-logo" />
              <h3>Tahoe Mountain Cars</h3>
            </div>
            <p>A new kind of rental experience for Sierra travelers</p>
          </div>

          <div className="footer-links">
            <div className="footer-section">
              <h4>Connect</h4>
              <ul>
                <li>
                  <a 
                    href="https://www.facebook.com/profile.php?id=61576602022697"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Facebook
                  </a>
                </li>
                <li>
                  <a 
                    href="https://www.instagram.com/tahoemountaincars"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Instagram
                  </a>
                </li>
                <li>
                  <a href="mailto:tahoemountaincars@gmail.com">
                    Email
                  </a>
                </li>
                <li>
                  <a href="https://blog.tahoemountaincars.com">
                    Blog
                  </a>
                </li>
              </ul>
            </div>

             <div className="footer-section">
              <h4>Legal</h4>
              <ul>
                <li>
                  <a href="#privacy-policy">
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Tahoe Mountain Cars. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
